<template>
    <AnalysisPane
      :community="community"
      :project="project"
      :get_kpi_fn="fetchMicroInfluenceKPIs"
    >
        <template v-if="kpis">

            <v-row class="project-cards__row row">
                <v-col v-for="podium in orderPodiums(kpis.microPodiums)" :key="podium.name" class="col-lg-6">
                    <ProjectCard
                            :title="'Micro-Influence Podium: ' + podium.name"
                            :subtitle="podiumSubtitle(podium)"
                            hint>
                        <template v-slot:tooltip>
                            <div v-if="podium.data.type == 'followers'">
                                Top three accounts from Lucy {{ podium.name }} by number of
                                followers among the community.
                            </div>
                            <div v-else-if="podium.data.type == 'topics'">
                                Top three social topics by the number of
                                members of the community.
                            </div>
                            <div v-else-if="podium.data.type == 'all-followers'">
                                Top three accounts by number of
                                followers among the community.
                            </div>
                            <div v-else-if="podium.data.type == 'followers-other'">
                              Top three accounts that are not part of any of podium communities,
                              by number of followers among the community.
                            </div>
                            <div v-else>
                            </div>
                        </template>
                        <Plotly  v-if="podium.data.Community.length > 0"
                                 :data="plotlify(podium.data)" :layout="{
                                    barmode: 'stack', 
                                    yaxis: {
                                        'showgrid': false,
                                    }
                                    }"/>
                        <span v-else>
                            <div v-if="podium.data.type == 'followers'">
                                Members of the community do not follow {{ podium.name }} accounts.
                            </div>
                            <div v-else-if="podium.data.type == 'topics'">
                                Member of the community don't tweet about social topics.
                            </div>
                            <div v-else>
                              Members of community do not follow anyone.
                            </div>
                        </span>
                        <template v-slot:hint>
                            {{ hintPodium(podium) }}
                        </template>
                    </ProjectCard>
                </v-col>
            </v-row>
          </template>
    </AnalysisPane>
</template>

<script>
    import _ from "lodash";
    import ProjectCard from "./../ProjectCard";
    import CommunityService from "../../../services/community.service";
    import {VueSvgGauge} from 'vue-svg-gauge'
    import {Plotly} from 'vue-plotly'
    import AnalysisPane from "./AnalysisPane"

    export default {
        name: "Micro-Influence",
        components: {ProjectCard, VueSvgGauge, Plotly, AnalysisPane},
        props: ["community", "project"],
        data: () => ({
            followersXScale: "linear",
            kpis: null,
            layout: {
                hovermode: 'closest'
            }
        }),
        methods: {
            _plotlify(d, name) {
                if(name === 'Community'){
                        return {
                        x: _.map(d.Community, e => e.x),
                        y: _.map(d.Community, e => e.y),
                        type: "bar",
                        name: name,
                        text: _.map(d.Community, e => e.y.toFixed(1) + "%"),
                        textposition: 'inside', 
                        insidetextanchor: 'middle',
                        marker: {color: '#0499fe' },
                        hoverinfo:'skip',
                    }
                }
                else return {
                        x: _.map(d.Panel, e => e.x),
                        y: _.map(d.Panel, e => 2.5),
                        type: "bar",
                        name: name,
                        text: d.Panel.map((e, idx) => "x" + (d.Community.at(idx).y / e.y).toFixed(0)),
                        textposition: 'inside', 
                        insidetextanchor: 'middle',
                        marker: {color: '#ffffff'},
                        hoverinfo:'skip',
                        showlegend:false,
                    }
            },
            plotlify(d) {
                return d ? [this._plotlify(d, "Community"),
                    this._plotlify(d, "Panel")] : []
            },
            hintPodium(podium) {
                let accounts = _.map(podium.data.Community, e => e.x)
                if (podium.data.type === 'followers') {
                    return accounts.join(", ") + ` are the most followed accounts from ${podium.name} among members of the community`
                } else if (podium.data.type === 'topics') {
                    return accounts.join(", ") + ` are the most discussed social topics among members of the community`
                } else if (podium.data.type === 'all-followers') {
                    return accounts.join(", ") + ` are the most followed accounts among members of the community`
                } else if (podium.data.type === 'followers-other') {
                    return accounts.join(", ") + ` are the most followed accounts other from podium communities among members of the community`
                } else {
                    return ""
                }
            },
            podiumSubtitle(podium) {
                if (podium.data.type === 'followers') {
                    return `% of members following accounts from ${podium.name}`
                } else if (podium.data.type === 'topics') {
                    return "% of members tweeting about social topic"
                } else {
                    return ""
                }
            },
            fetchMicroInfluenceKPIs() {
              var cs = new CommunityService();
              return cs.getMicroInfluenceKPIs(
                  {
                      startDate: this.project.timeframe_start,
                      endDate: this.project.timeframe_end,
                      query: this.community
                  },
                  null
              ).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.kpis = resp.data
                  }
                  return resp;
              })
            },
            orderPodiums(podiums) {
                // Take a list of podiums and return those in expected order on page
                var local_podiums = [...podiums];
                var expected_order = [
                  "Media",
                  "Journalists",
                  "TV Shows",
                  "International Organizations",
                  "State Organizations",
                  "International Politicians",
                  "National Politicians",
                  "Regional Politicians",
                  "Brands",
                  "Youtubers",
                  "Influencers",
                  "Most followed accounts",
                  "Social topics"
                ];

                return local_podiums.sort(function(a, b) {
                  var ia = expected_order.indexOf(a.name);
                  var ib = expected_order.indexOf(b.name);
                  if (ia < ib) {
                    return -1;
                  }
                  if (ia > ib) {
                    return 1;
                  }
                  return 0;
                });
            }
        },
    }
</script>

<style scoped>
    .inner-text {
        height: 100%;
        width: 100%;
        margin-top: 85px

    }

    .inner-text span {
        max-width: 100px;
        color: red;
        display: flex;
        align-items: center;
        justify-content: center
    }

    .kpi-value {
        align-items: center;
        justify-content: center;
        text-align: center
    }
</style>
